export const actionHistoryType = {

    CHANGE_CURRENT_URL: 'CHANGE_CURRENT_URL',

    CHANGE_CURRENT_TAB: 'CHANGE_CURRENT_TAB',

    CHANGE_CURRENT_ACTION: 'CHANGE_CURRENT_ACTION',

    CHANGE_UNLOAD_ACTION_HISTORY: 'CHANGE_UNLOAD_ACTION_HISTORY',

    CHANGE_FORBIDDEN :'CHANGE_FORBIDDEN',
}